import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { NoteContentDocumentViewer } from "@/pages/notes/components/note-content-documents/viewer";
import { NoteEventTimeline } from "@/pages/notes/view/note-event-timeline";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useParams } from "react-router";
import { Button, Flex } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { atlasRoutes } from "@/app/router/routes";

export const NotesViewPage: FC = () => {
  const { noteId } = useParams<{ noteId: Uuid }>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  if (!noteId) {
    return <div>Invalid ID</div>;
  }

  const noteResult = useQuery({
    queryKey: ["note", noteId],
    queryFn: () =>
      api.get("/internal/v1/notes/{note_id}", {
        params: {
          path: {
            note_id: noteId,
          },
        },
      }),
  });

  const restoreNoteMutation = useMutation({
    mutationFn: async () => {
      if (!noteResult.data?.data?.owned_by_space_account_id) {
        throw new Error("Note owner account ID not available");
      }

      return api.post("/internal/v1/notes/{note_id}/restore", {
        params: {
          path: {
            note_id: noteId,
          },
        },
        body: {
          owner_space_account_id: noteResult.data.data.owned_by_space_account_id,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["note", noteId] });
    },
  });

  const isNoteTrashed = noteResult.data?.data?.trashed_at !== null;

  return (
    <div>
      <Flex justify="between" align="center" mb="4">
        <h1>View Note</h1>
        <Flex gap="2">
          {isNoteTrashed && (
            <Button
              onClick={() => restoreNoteMutation.mutate()}
              disabled={restoreNoteMutation.isPending}
              variant="solid"
              color="green"
            >
              {restoreNoteMutation.isPending ? "Restoring..." : "Restore Note"}
            </Button>
          )}
          <Button
            onClick={() => navigate(atlasRoutes.notesUploadAudio({ params: { noteId } }).path)}
          >
            Upload Audio Recording
          </Button>
          <Button onClick={() => navigate(atlasRoutes.notesSnapshots({ params: { noteId } }).path)}>
            View History
          </Button>
        </Flex>
      </Flex>
      <br />
      <br />
      <pre>{JSON.stringify(noteResult.data, null, 2)}</pre>
      <br />
      <br />
      <br />
      <br />
      <br />
      <NoteContentDocumentViewer noteId={noteId} />
      <br />
      <br />
      <br />
      <NoteEventTimeline noteId={noteId} createdAt={noteResult.data?.data?.locally_created_at} />
      <br />
      <br />
      <br />
    </div>
  );
};
